export const LOCKED_SETTINGS_QUERY_KEY = "lockedSettings";

const LOCKED_SETTING_ALIASES = {
  ticker: ["ticker_as_link"],
  ticker_as_link: ["ticker"]
};

export function normalizeLockedSettings(value) {
  if (Array.isArray(value)) {
    return value.filter(key => typeof key === "string" && key.length);
  }

  if (typeof value === "string" && value.length) {
    return [value];
  }

  return [];
}

export function isSettingLocked(lockedSettings, key) {
  return normalizeLockedSettings(lockedSettings).indexOf(key) !== -1;
}

export function isFilterAttributeLocked(lockedSettings, attribute) {
  if (isSettingLocked(lockedSettings, attribute)) {
    return true;
  }

  const aliases = LOCKED_SETTING_ALIASES[attribute] || [];

  return aliases.some(alias => isSettingLocked(lockedSettings, alias));
}

export function getVisibleActiveFilterKeys(
  keys,
  excludedSettings,
  lockedSettings
) {
  const excluded = excludedSettings || [];

  return (keys || []).filter(
    key =>
      isSettingLocked(lockedSettings, key) || excluded.indexOf(key) === -1
  );
}

export function preserveLockedRecord(
  nextRecord = {},
  previousRecord = {},
  lockedSettings
) {
  const preserved = { ...nextRecord };

  normalizeLockedSettings(lockedSettings).forEach(key => {
    if (Object.prototype.hasOwnProperty.call(previousRecord, key)) {
      preserved[key] = previousRecord[key];
    } else {
      delete preserved[key];
    }
  });

  return preserved;
}
